import { Link } from 'react-router'
import { TrustGauge } from '@carouselgg/nexus/trust-gauge'
import { ArrowLeft } from '@carouselgg/nexus/icon'
import { useAuthStore } from '@carouselgg/auth/store'
import type { HubReturn } from './hubReturn'
import styles from './HubSidebarHeader.module.css'

interface HubSidebarHeaderProps {
  back: HubReturn
  /** Desktop rail: just the back arrow and the ringed avatar. */
  collapsed?: boolean
  onNavigate?: () => void
}

/**
 * Top of the side nav inside the account hub: the way back to the page you
 * came from, named, then whose account this is. Replaces the identity block,
 * whose trust panel would only point back into the hub.
 */
export function HubSidebarHeader({ back, collapsed, onNavigate }: HubSidebarHeaderProps) {
  const user = useAuthStore((s) => s.user)
  const trustScore = useAuthStore((s) => s.trustScore)
  const name = user ? user.gamer_tag || user.username : ''
  const score = trustScore?.score ?? null

  return (
    <div className={[styles.header, collapsed && styles.collapsed].filter(Boolean).join(' ')}>
      <Link
        to={back.to}
        className={styles.back}
        onClick={onNavigate}
        aria-label={`Back to ${back.label}`}
      >
        <ArrowLeft size={18} className={styles.arrow} aria-hidden="true" />
        <span className={styles.backText} aria-hidden="true">
          <span className={styles.backEyebrow}>Back to</span>
          <span className={styles.backLabel}>{back.label}</span>
        </span>
      </Link>

      {user && (
        <div className={styles.account}>
          <TrustGauge score={score ?? 0} size={collapsed ? 32 : 40} title={score === null ? 'Trust score' : undefined}>
            {user.avatar_url
              ? <img src={user.avatar_url} alt="" className={styles.avatar} />
              : name.charAt(0).toUpperCase()}
          </TrustGauge>
          <span className={styles.who}>
            <span className={styles.title}>Your account</span>
            <span className={styles.meta}>
              {name}
              {score !== null && <> · <strong className={styles.score}>{score}</strong> {trustScore?.level}</>}
            </span>
          </span>
        </div>
      )}
    </div>
  )
}
